import { Button, Typography } from '@breetometer/components';
import { viewHelpArticle } from 'BreetHelpers';
import { useModalApi } from 'BreetHooks';

import tooltipImage from '@/assets/images/tooltip-image.webp';

import ImageComponent from '../ImageComponent';
import { pageDataMap, type TooltipPageType } from './DialogTooltip.helpers';

const DialogTooltip = () => {
	const { getModalProps } = useModalApi();

	const { metadata } = getModalProps('tooltip') as { metadata: { page: TooltipPageType } | undefined };

	const pageData = metadata?.page ? pageDataMap[metadata.page] : { label: 'No label', description: 'No description', link: '' };

	return (
		<div className='dialog-tool-tip'>
			<div className='img-section'>
				<ImageComponent
					src={tooltipImage}
					alt='tool tip image'
				/>
			</div>

			<div className='txt-section'>
				<Typography as='h5'>{pageData.label}</Typography>
				<Typography>{pageData.description}</Typography>
			</div>

			{!!pageData.link && <Button onClick={viewHelpArticle(pageData.link)}>Learn More</Button>}
		</div>
	);
};

export default DialogTooltip;
